<template>
  <div>
    <div v-for="(eligibility, index) in eligibilityInputs" :key="index">
      <div class="card-item shadowless">
        <div v-if="eligibility.inputOrigin === 'EXTERNAL_PROVIDER'" class="container-automatic">
          <div class="container-automatic-input">
            <span class="label-text">
              <b> {{ automaticTitles[index] }}: </b>
            </span>
            <BaseInput
              :id="`eligibility-automatic-input-${index}`"
              class="eligibility-input-automatic"
              disabled
              :value="eligibility.value"
              type="text" />
            <small :id="`external-provider-${index}`" class="external-provider-equifax">Equifax</small>
          </div>
          <div class="container-forced-switch">
            <small v-show="eligibility.forcedValue" class="check-passed">Aprobado</small>
            <small v-show="!eligibility.forcedValue" class="check-forced">Forzar aprobación</small>
            <b-switch
              :id="`0-eligibility-criteria-${index}`"
              v-model="eligibility.forcedValue"
              :class="`check-${eligibility.forcedValue}`"
              :disabled="false"
              :native-value="false"
              :true-value="true"
              :false-value="false"
              @input="updateSwitchs($event, index)" />
          </div>
        </div>
        <div v-if="eligibility.inputOrigin === 'USER_SWITCH'" class="container-switch">
          <span> <b> {{ titles[index] }} </b> </span>
          <b-switch
            :id="`0-eligibility-criteria-${index}`"
            v-model="eligibility.forcedValue"
            :class="`check-${eligibility.forcedValue}`"
            :disabled="false"
            :native-value="false"
            :true-value="true"
            :false-value="false"
            @input="updateSwitchs($event, index)" />
        </div>
        <div v-if="eligibility.forcedValue" class="is-flex is-align-items-center mt-2">
          <p class="label-text-coment"><b>Comentario:</b></p>
          <BaseInput
            :id="`eligibility-comment-input-${index}`"
            class="eligibility-input"
            :value="eligibility.comment"
            type="text"
            @input="newValue => addComment(newValue, index)" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseInput from '@/ui/components/internal/risk-evaluation/BaseInput.vue';

export default {
  name: 'EligibilityInputs',
  components: { BaseInput },
  props: {
    value: { type: Object, default: () => ({}) },
    debtorIndex: { type: Number, default: null }
  },
  data() {
    return {
      eligibilityInputs: {},
      titles: {
        age: 'Cumple con los requisitos de edad',
        defaultingDebtsOrProtests: 'No tiene deuda informada en dicom',
        financialCourtCases: 'No tiene causas judiciales',
        sixMonthsAntiquity: 'Tiene más de 6 meses de antiguedad',
        twelveMonthsEmploymentContinuity: 'Tiene continuidad laboral de más de 12',
        nationalityOrResidence: 'Tiene nacionalidad chilena o residencia permanente'
      },
      automaticTitles: {
        age: 'Edad',
        defaultingDebtsOrProtests: 'Deuda informada en dicom',
        nationalityOrResidence: 'Nacionalidad',
        financialCourtCases: '',
        sixMonthsAntiquity: '',
        twelveMonthsEmploymentContinuity: ''
      }
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(vModelValues) {
        if (vModelValues) {
          this.eligibilityInputs = vModelValues;
        }
      }
    }
  },
  methods: {
    addComment(value, glossIndex) {
      this.eligibilityInputs[glossIndex].comment = value;
      this.$emit('switch-eligibility-value', this.eligibilityInputs);
    },
    updateSwitchs(value, glossIndex) {
      this.eligibilityInputs[glossIndex].forcedValue = value;
      this.$emit('switch-eligibility-value', this.eligibilityInputs);
    }
  }
};
</script>
<style>
.container-forced-switch {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px;
}
.check-forced {
  color: #787878;
  margin-right: 1rem;
}
.check-passed {
  color: #00D1B2;
  margin-right: 1rem;
}
.container-automatic {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.container-automatic-input {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.container-switch {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px;
}
.card-item {
  overflow: visible;
  margin-bottom: 1rem;
}
.eligibility-input {
  width: 100%;
}
.eligibility-input-automatic {
  margin-right: 1rem;
}
.label-text {
  width: auto;
  min-width: 115px;
}
.label-text > b {
  margin-right: 1rem;
}
.external-provider-equifax {
  color: #00CCD1;
}
.label-text-coment {
  width: 130px;
}
</style>
